export const FETCH_EMPLOYEES = 'employee/FETCH_EMPLOYEES'
export const FETCH_EMPLOYEES_SUCCESS = 'employee/FETCH_EMPLOYEES_SUCCESS'
export const FETCH_EMPLOYEES_FAILURE = 'employee/FETCH_EMPLOYEES_FAILURE'
export const RESET_EMPLOYEES = 'employee/RESET_EMPLOYEES'

export const FETCH_EMPLOYEE = 'employee/FETCH_EMPLOYEE'
export const FETCH_EMPLOYEE_SUCCESS = 'employee/FETCH_EMPLOYEE_SUCCESS'
export const FETCH_EMPLOYEE_FAILURE = 'employee/FETCH_EMPLOYEE_FAILURE'
export const RESET_EMPLOYEE = 'employee/RESET_EMPLOYEE'

export const CREATE_EMPLOYEE = 'employee/CREATE_EMPLOYEE'
export const CREATE_EMPLOYEE_SUCCESS = 'employee/CREATE_EMPLOYEE_SUCCESS'
export const CREATE_EMPLOYEE_FAILURE = 'employee/CREATE_EMPLOYEE_FAILURE'
export const RESET_CREATE_EMPLOYEE = 'employee/RESET_CREATE_EMPLOYEE'

export const UPDATE_EMPLOYEE = 'employee/UPDATE_EMPLOYEE'
export const UPDATE_EMPLOYEE_SUCCESS = 'employee/UPDATE_EMPLOYEE_SUCCESS'
export const UPDATE_EMPLOYEE_FAILURE = 'employee/UPDATE_EMPLOYEE_FAILURE'
export const RESET_UPDATE_EMPLOYEE = 'employee/RESET_UPDATE_EMPLOYEE'

export const UPDATE_EMPLOYEE_STATE = 'employee/UPDATE_EMPLOYEE_STATE'
export const UPDATE_EMPLOYEE_STATE_SUCCESS = 'employee/UPDATE_EMPLOYEE_STATE_SUCCESS'
export const UPDATE_EMPLOYEE_STATE_FAILURE = 'employee/UPDATE_EMPLOYEE_STATE_FAILURE'
export const RESET_UPDATE_EMPLOYEE_STATE = 'employee/RESET_UPDATE_EMPLOYEE_STATE'

export const DELETE_EMPLOYEE = 'employee/DELETE_EMPLOYEE'
export const DELETE_EMPLOYEE_SUCCESS = 'employee/DELETE_EMPLOYEE_SUCCESS'
export const DELETE_EMPLOYEE_FAILURE = 'employee/DELETE_EMPLOYEE_FAILURE'
export const RESET_DELETE_EMPLOYEE = 'employee/RESET_DELETE_EMPLOYEE'

export const UPLOAD_EMPLOYEE_PHOTO = 'employee/UPLOAD_EMPLOYEE_PHOTO'
export const UPLOAD_EMPLOYEE_PHOTO_SUCCESS = 'employee/UPLOAD_EMPLOYEE_PHOTO_SUCCESS'
export const UPLOAD_EMPLOYEE_PHOTO_FAILURE = 'employee/UPLOAD_EMPLOYEE_PHOTO_FAILURE'
export const RESET_UPLOAD_EMPLOYEE_PHOTO = 'employee/RESET_UPLOAD_EMPLOYEE_PHOTO'

export const DELETE_EMPLOYEE_PHOTO = 'employee/DELETE_EMPLOYEE_PHOTO'
export const DELETE_EMPLOYEE_PHOTO_SUCCESS = 'employee/DELETE_EMPLOYEE_PHOTO_SUCCESS'
export const DELETE_EMPLOYEE_PHOTO_FAILURE = 'employee/DELETE_EMPLOYEE_PHOTO_FAILURE'
export const RESET_DELETE_EMPLOYEE_PHOTO = 'employee/RESET_DELETE_EMPLOYEE_PHOTO'

export const FETCH_EMPLOYEE_SELLS = 'employee/FETCH_EMPLOYEE_SELLS'
export const FETCH_EMPLOYEE_SELLS_SUCCESS = 'employee/FETCH_EMPLOYEE_SELLS_SUCCESS'
export const FETCH_EMPLOYEE_SELLS_FAILURE = 'employee/FETCH_EMPLOYEE_SELLS_FAILURE'
export const RESET_EMPLOYEE_SELLS = 'employee/RESET_EMPLOYEE_SELLS'

export const FETCH_EMPLOYEE_SELLS_ITEMS = 'employee/FETCH_EMPLOYEE_SELLS_ITEMS'
export const FETCH_EMPLOYEE_SELLS_ITEMS_SUCCESS = 'employee/FETCH_EMPLOYEE_SELLS_ITEMS_SUCCESS'
export const FETCH_EMPLOYEE_SELLS_ITEMS_FAILURE = 'employee/FETCH_EMPLOYEE_SELLS_ITEMS_FAILURE'
export const RESET_EMPLOYEE_SELLS_ITEMS = 'employee/RESET_EMPLOYEE_SELLS_ITEMS'

export const FETCH_EMPLOYEES_BY_STORE = 'employee/FETCH_EMPLOYEES_BY_STORE'
export const FETCH_EMPLOYEES_BY_STORE_SUCCESS = 'employee/FETCH_EMPLOYEES_BY_STORE_SUCCESS'
export const FETCH_EMPLOYEES_BY_STORE_FAILURE = 'employee/FETCH_EMPLOYEES_BY_STORE_FAILURE'
export const RESET_EMPLOYEES_BY_STORE = 'employee/RESET_EMPLOYEES_BY_STORE'



// WEBPACK FOOTER //
// ./src/store/employee/actionTypes.js